import {
  IAddDualLangInspectionNote,
  IDualLangInspectionNoteProperties,
  IUpdateDualLangInspectionNote,
} from "mobx-stores/_models/inspection-note/dual-lang-inspection-note/dual-lang-inspection-note";
import { BaseBussiness } from "../../base";

class DualLangInspectionNoteBusiness extends BaseBussiness<
  IDualLangInspectionNoteProperties,
  IAddDualLangInspectionNote,
  IUpdateDualLangInspectionNote,
  IDualLangInspectionNoteProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
}

export const dualLangInspectionNoteBusiness =
  new DualLangInspectionNoteBusiness("/api/app/inspection-note-sn");
